import { Loader, Menu } from "@mantine/core";
import { IIssueBoardApi } from "@mcapps/shared";
import { IIssueApi } from "@schemas/issueSchema";
import { IconArrowMoveDown } from "@tabler/icons-react";
import React from "react";
import { useHistory } from "react-router";
import { useGetProjectByProjectIdIssueboardQuery } from "../../../../../../../openapi";
import { ISSUE_BOARD_STATUSES } from "../../../issueConstants";
import { useChangeBoardOfIssueItemMutation } from "../../../issueRTKLegacy";

type ChangeItemRegisterSelectorProps = {
  issue: IIssueApi;
  projectId: string;
  activeBoard: { _id?: string };
};

const IssueChangeRegisterSelectorSubMenu = ({ issue, projectId, activeBoard }: ChangeItemRegisterSelectorProps) => {
  const history = useHistory();

  const { data: issueBoards, isLoading: issueBoardsLoading } = useGetProjectByProjectIdIssueboardQuery({ projectId });
  const [changeBoardOfIssue] = useChangeBoardOfIssueItemMutation();

  const _changeBoardOfIssue = (boardId: string) => {
    history.replace(history.location.pathname);
    changeBoardOfIssue({
      issueId: issue._id,
      projectId,
      boardIdToChangeTo: boardId,
    });
  };

  const groupedBoards: GroupedBoardsByStatusArgs = React.useMemo(() => groupBoardsByStatus(issueBoards), [issueBoards]);

  return (
    <Menu.Sub closeDelay={150}>
      <Menu.Sub.Target>
        <Menu.Sub.Item leftSection={<IconArrowMoveDown size={16} />}>Flytt til register</Menu.Sub.Item>
      </Menu.Sub.Target>

      <Menu.Sub.Dropdown mah="60vh" style={{ overflowY: "auto" }}>
        {issueBoardsLoading ? (
          <Menu.Item>
            <Loader size={16} />
          </Menu.Item>
        ) : (
          groupedBoards.map((group, index) => (
            <div key={group.group}>
              <Menu.Label>{group.group}</Menu.Label>
              {group.items.map((item) => (
                <Menu.Item
                  key={item.value}
                  onClick={() => {
                    _changeBoardOfIssue(item.value);
                  }}
                  disabled={item.value === activeBoard?._id}
                >
                  {item.label}
                </Menu.Item>
              ))}
              {index < groupedBoards.length - 1 && <Menu.Divider />}
            </div>
          ))
        )}
      </Menu.Sub.Dropdown>
    </Menu.Sub>
  );
};

type GroupedBoardsByStatusArgs = { group: string; items: { value: string; label: string }[] }[];

const groupBoardsByStatus = (boards: IIssueBoardApi[]): GroupedBoardsByStatusArgs => {
  if (boards == null) {
    return [];
  }

  const statuses = new Map<string, { value: string; label: string }[]>();

  ISSUE_BOARD_STATUSES.forEach((status) => {
    statuses.set(status.label, []);
  });

  boards
    .filter((b) => b.status.toLocaleLowerCase() !== "deleted")
    .forEach((board) => {
      const status = ISSUE_BOARD_STATUSES.find((status) => status.value === board.status);

      if (status != null) {
        statuses.get(status.label).push({ value: board._id, label: board.name });
      }
    });

  const groupedBoards: GroupedBoardsByStatusArgs = [];

  statuses.forEach((items, group) => {
    if (items.length > 0) {
      groupedBoards.push({ group, items });
    }
  });

  return groupedBoards;
};

export default IssueChangeRegisterSelectorSubMenu;
